/*
 * =================================================================
 * ORTHOMEN PRODUCT PAGE MASTER SCRIPT (orthomen25.js)
 * FINAL & CONSOLIDATED VERSION
 * =================================================================
 * All page scripts are now safely contained within a single
 * 'DOMContentLoaded' event listener to prevent conflicts and
 * ensure proper execution order.
 */
document.addEventListener('DOMContentLoaded', function() {

    // -----------------------------------------------------------------
    // MODULE 1: ACCORDIONS (For FAQ and other collapsible sections)
    // -----------------------------------------------------------------
    const accordionContainers = document.querySelectorAll('.pdp-main-content-sidebar .accordion');
    accordionContainers.forEach(container => {
        const headers = container.querySelectorAll('.accordion-header');
        headers.forEach(header => {
            header.addEventListener('click', function(event) {
                event.preventDefault();
                const content = this.nextElementSibling;
                if (!content) return;
                const isExpanded = this.getAttribute('aria-expanded') === 'true';
                this.setAttribute('aria-expanded', String(!isExpanded));
                if (!isExpanded) {
                    content.style.maxHeight = content.scrollHeight + "px";
                } else {
                    content.style.maxHeight = null;
                }
            });
        });
    });

    // -----------------------------------------------------------------
    // MODULE 2: FEATURE SUMMARY EXPANDER ("About this item" See more/less)
    // -----------------------------------------------------------------
    const featureSummary = document.querySelector('.pdp-main-content-sidebar .pdp-feature-summary');
    if (featureSummary) {
        const toggleButton = featureSummary.querySelector('.summary-toggle-button');
        const listContainer = featureSummary.querySelector('.summary-list-container');
        const buttonText = toggleButton.querySelector('.button-text');
        if (toggleButton && listContainer && buttonText) {
            toggleButton.addEventListener('click', function(e) {
                e.preventDefault();
                const isExpanded = this.getAttribute('aria-expanded') === 'true';
                this.setAttribute('aria-expanded', String(!isExpanded));
                listContainer.classList.toggle('is-expanded');
                if (!isExpanded) {
                    listContainer.style.maxHeight = listContainer.scrollHeight + 'px';
                    buttonText.textContent = 'See less';
                } else {
                    listContainer.style.maxHeight = listContainer.scrollHeight + 'px';
                    requestAnimationFrame(() => {
                        listContainer.style.maxHeight = '105px';
                    });
                    buttonText.textContent = 'See more';
                }
            });
        }
    }

    // -----------------------------------------------------------------
    // MODULE 3: YOUTUBE SHORTS SLIDER
    // -----------------------------------------------------------------
    const sliderOuters = document.querySelectorAll('.pdp-main-content-sidebar .pdp-youtube-shorts-slider .shorts-slider-outer-container');
    sliderOuters.forEach(sliderOuter => {
        const container = sliderOuter.querySelector('.shorts-slider-container');
        const track = sliderOuter.querySelector('.shorts-slider-track');
        const prevArrow = sliderOuter.querySelector('.prev-arrow');
        const nextArrow = sliderOuter.querySelector('.next-arrow');
        const items = sliderOuter.querySelectorAll('.short-video-item');

        if (!container || !track || !prevArrow || !nextArrow || items.length === 0) {
            if (prevArrow) prevArrow.style.display = 'none';
            if (nextArrow) nextArrow.style.display = 'none';
            return;
        }

        let currentIndex = 0;
        let itemWidth = 0;
        let gap = 0;

        function calculateParams() {
            if (items.length > 0 && items[0].offsetWidth > 0) {
                itemWidth = items[0].offsetWidth;
                gap = parseInt(window.getComputedStyle(track).gap) || 15;
                return true;
            }
            return false;
        }

        function getVisibleCount() {
            if (!container || itemWidth === 0) return 1;
            return Math.max(1, Math.floor((container.offsetWidth + gap) / (itemWidth + gap)));
        }

        function updateSlider() {
            if (!calculateParams()) {
                if(prevArrow) prevArrow.style.display = 'none';
                if(nextArrow) nextArrow.style.display = 'none';
                return;
            }
            const visibleItems = getVisibleCount();
            const maxIndex = Math.max(0, items.length - visibleItems);

            currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));
            
            const offset = currentIndex * (itemWidth + gap);
            track.style.transform = `translateX(-${offset}px)`;

            prevArrow.style.display = currentIndex === 0 ? 'none' : 'flex';
            nextArrow.style.display = currentIndex >= maxIndex ? 'none' : 'flex';
        }

        prevArrow.addEventListener('click', (e) => { e.preventDefault(); if (currentIndex > 0) { currentIndex--; updateSlider(); } });
        nextArrow.addEventListener('click', (e) => { e.preventDefault(); const v = getVisibleCount(); if (currentIndex < items.length - v) { currentIndex++; updateSlider(); } });

        const initializeSlider = () => setTimeout(updateSlider, 150);
        
        if (document.readyState === 'complete') { initializeSlider(); } 
        else { window.addEventListener('load', initializeSlider); }

        let resizeTimeout;
        window.addEventListener('resize', () => { clearTimeout(resizeTimeout); resizeTimeout = setTimeout(updateSlider, 250); });
    });


    // -----------------------------------------------------------------
    // MODULE 4: ORTHOMEN CUSTOM UNIQUE VIDEO GALLERY
    // -----------------------------------------------------------------
    const playlist = document.getElementById('orthomencustom-playlist');
    const mainPlayerContainer = document.getElementById('orthomencustom-main-player');

    if (playlist && mainPlayerContainer) {
        const videoItems = playlist.querySelectorAll('.orthomencustom-vidgallery-playlist-item');

        const updatePlayer = (type, id) => {
            mainPlayerContainer.innerHTML = '';
            let playerElement;
            if (type === 'youtube') {
                playerElement = document.createElement('iframe');
                playerElement.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`;
                playerElement.setAttribute('frameborder', '0');
                playerElement.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
                playerElement.setAttribute('allowfullscreen', '');
            } else if (type === 'direct') {
                playerElement = document.createElement('video');
                playerElement.src = id; // Note: You had youtube IDs for direct videos, ensure these are correct .mp4 URLs
                playerElement.setAttribute('controls', '');
                playerElement.setAttribute('autoplay', '');
                playerElement.setAttribute('playsinline', '');
            }
            if (playerElement) {
                mainPlayerContainer.appendChild(playerElement);
            }
        };

        playlist.addEventListener('click', (event) => {
            // **FIXED**: If the product link is clicked, do nothing and let the browser navigate.
            if (event.target.classList.contains('orthomencustom-vidgallery-product-link')) {
                return;
            }
            const clickedItem = event.target.closest('.orthomencustom-vidgallery-playlist-item');
            if (!clickedItem || clickedItem.classList.contains('is-active')) return;
            
            const videoType = clickedItem.dataset.videoType;
            const videoId = clickedItem.dataset.videoId;
            
            videoItems.forEach(item => item.classList.remove('is-active'));
            clickedItem.classList.add('is-active');
            updatePlayer(videoType, videoId);
        });
        
        const firstVideoItem = videoItems[0];
        if (firstVideoItem) {
            firstVideoItem.classList.add('is-active');
            const firstVideoType = firstVideoItem.dataset.videoType;
            const firstVideoId = firstVideoItem.dataset.videoId;
            if (firstVideoType === 'youtube') {
                 mainPlayerContainer.innerHTML = `<iframe src="https://www.youtube.com/embed/${firstVideoId}?rel=0&modestbranding=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            } else if (firstVideoType === 'direct') {
                const posterUrl = firstVideoItem.querySelector('img') ? firstVideoItem.querySelector('img').src : '';
                mainPlayerContainer.innerHTML = `<video src="${firstVideoId}" controls playsinline poster="${posterUrl}"></video>`;
            }
        }
    } else {
        console.warn('Orthomen Video Gallery: Required elements not found on this page.');
    }



    
});